import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import TemplateDetailsPage, { getDefaultUI } from 'components/pages/TemplateDetailsPage';
import Classes from "model";

export default function CaptureAddNewTypeModalDDOpen(props) {
  const context = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, context);

  const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update(["transactionTypeSelectIsActive", "isActive"], true)
    .submit();

  return (
    <TemplateDetailsPage ui={ui} />
  )
}
